import Vorschaden from './input/Vorschaden';
import VorschFreitext from './input/VorschFreitext';
import TransitionCollapse from "../../../../transition/TransitionCollapse";
import useWizardFormCtx from '../../ctx-provider/useWizardFormCtx';
import StvJaNeinUnbekannt from '../../../../../consumer/form/dto/StvJaNeinUnbekannt';

const FormVorschaden: React.FC = () => {
    const { wizardFormBo } = useWizardFormCtx();
    const render = wizardFormBo.antrag.vorschaden === StvJaNeinUnbekannt.JA;
    return (
        <>
            <Vorschaden />
            <TransitionCollapse show={render}>
                <div style={{ marginTop: 10 }}>
                    <VorschFreitext />
                </div>
            </TransitionCollapse >
        </>
    );
}

export default FormVorschaden;